import React, { Component } from 'react';
import './AdvCriteriaPopup.css';
import PopupTitleBar from './PopupTitleBar';
import SelectionBox from '../SelectionBox';
import Config from '../../Configs/criteria.json'

const NUM_OF_COLUMN = 4;
const MAX_NUM_OF_SELECTION = 10;
const boxheight=120;
const boxMarginTop=750;
export default class AdvCriteriaPopup extends Component {
    constructor(props) {
        super(props);
        // this.closePopupHandler = this.closePopupHandler.bind(this);
        // this.handleOnClick = this.handleOnClick.bind(this);
        this.advanced = JSON.parse(JSON.stringify(props.criteria));
        this.state = {
            mode: "full",
            section: "financial",
            advanced: this.advanced,
            showErrMsg:"off",
            boxMarginTop:boxMarginTop
        };
    }
    handleOnClick = (section) => (e) => {
        this.setState({ section });
    }
    handleModeChange = (mode) => {
        this.setState({ mode });
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        if (this.getNumberOfSelectedItem() < 10 || this.advanced[name][value].selected) {
            if (!this.advanced[name][value].selected) {
                this.advanced[name][value].enabled = true;
            }
            this.advanced[name][value].selected = ischecked;
            this.setState({ advanced: this.advanced ,showErrMsg:"off"});
        }else{
            this.setState({ showErrMsg:"on" });

        }
    }
    handleConfirm = () => {
        this.props.submit(this.state.advanced);
        this.closePopupHandler();
    }
    closePopupHandler = () => {
        this.props.closePopup();
    }
    getNumberOfSelectedItemByType = (type) => {
        let count = 0;
        for (let i=0; i<this.state.advanced[type].length; i++) {
            if (this.state.advanced[type][i].selected) {
                count++;
            }
        }
        return count;
    }
    getNumberOfSelectedItem = () => {
        let type = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            type.push(key);
        });
        let count = 0;
        for (let i=0; i<type.length; i++) {
            for (let j=0; j<this.state.advanced[type[i]].length; j++) {
                if (this.state.advanced[type[i]][j].selected) {
                    count++;
                }
            }
        }
        return count;
    }
    getNumberOfItemPerColumn = (type,i) => {
        if(type==="priceperf"){
            return 9;
        }
        if(type==="technical"){
            return 8;
        }
        return ~~(Config.criteria.advanced[type].length / NUM_OF_COLUMN)+1;

    }
    generateSimpleCriteria = (type) => {
        let items = [];
        if (Array.isArray(type)) {
            for (let h=0; h<type.length; h++) {
                for (let i=0; i<Config.criteria.advanced[type[h]].length; i++) {
                    if (Config.criteria.advanced[type[h]][i].simple) {
                        items.push(<SelectionBox key={Config.criteria.advanced[type[h]][i].id} label={Config.criteria.advanced[type[h]][i].name2} name={type[h]} value={i} tooltip={Config.criteria.advanced[type[h]][i].tooltip} onChange={this.handleSelectionBoxChange} ischecked={this.state.advanced[type[h]][i].selected} />);
                    }
                }
            }
        } else {
            for (let i=0; i<Config.criteria.advanced[type].length; i++) {
                if (Config.criteria.advanced[type][i].simple) {
                    items.push(<SelectionBox key={Config.criteria.advanced[type][i].id} label={Config.criteria.advanced[type][i].name2} name={type} value={i} tooltip={Config.criteria.advanced[type][i].tooltip} onChange={this.handleSelectionBoxChange} ischecked={this.state.advanced[type][i].selected} />);
                }
            }
        }
        return <div className="subcontainer">{items}</div>;
    }
    generateCriteria = (type) => {
        let column = [];
        for (let i=0; i<NUM_OF_COLUMN; i++) {
            let items = [];
            for (let j=i*this.getNumberOfItemPerColumn(type,i); j<i*this.getNumberOfItemPerColumn(type,i)+this.getNumberOfItemPerColumn(type,i); j++) {
                // console.log(type+" || j:"+j);
                if (j>=Config.criteria.advanced[type].length) break;
                items.push(<SelectionBox key={Config.criteria.advanced[type][j].id} label={Config.criteria.advanced[type][j].name2} name={type} value={j} tooltip={Config.criteria.advanced[type][j].tooltip} onChange={this.handleSelectionBoxChange} ischecked={this.state.advanced[type][j].selected} />);
            }
            column.push(<div key={type+i} className="subcontainer">{items}</div>);
        }
        return column;
    }
    generateCriteriaPriceperf = (type) => {
        let column = [];
        let numCol=9;
        let tempPos=0;
        for (let i=0; i<NUM_OF_COLUMN; i++) {
            let items = [];
            numCol=i==1?8:9
            for (let j=0; j<numCol; j++) {
                // console.log(type+" || j:"+tempPos);
                if (tempPos>=Config.criteria.advanced[type].length) break;
                items.push(<SelectionBox key={Config.criteria.advanced[type][tempPos].id} label={Config.criteria.advanced[type][tempPos].name2} name={type} value={tempPos} tooltip={Config.criteria.advanced[type][tempPos].tooltip} onChange={this.handleSelectionBoxChange} ischecked={this.state.advanced[type][tempPos].selected} />);
                tempPos++;
            }
            column.push(<div key={type+i} className="subcontainer">{items}</div>);
        }
        return column;
    }
    componentDidMount(){
        if(this.props.appId!=="Hyper"){this.setState({ boxMarginTop:boxMarginTop+((this.getNumberOfSelectedItem())*boxheight)});}
    }
    render() {
        return (
            <div className={this.props.appId==="Hyper"?"AdvCriteriaPopup Hyper":"AdvCriteriaPopup"} style={{marginTop:this.props.appId==="Hyper"?"auto":this.state.boxMarginTop}}>
                <PopupTitleBar title={"詳細条件項目 " + this.getNumberOfSelectedItem() + "/" + MAX_NUM_OF_SELECTION} handleModeChange={this.handleModeChange} closePopup={this.closePopupHandler} mode={this.state.mode} />
                <div className="cntErrorMsg"  style={{display: this.state.showErrMsg==="on"?"block":"none"}} >{Config.CountErrMsg}</div>
                <div className="fullmode" style={{display: this.state.mode==="simple"?"none":"block"}}>
                    <div className="CriteriaMenuBar">
                        <ul>
                            <li className={this.state.section==="financial" ? "selected" : ""} onClick={this.handleOnClick('financial')}><div className="wrapper"><div className="text">財務</div><div className="counter" style={{display: this.getNumberOfSelectedItemByType("financial")>0?"block":"none"}}>{this.getNumberOfSelectedItemByType("financial")}</div></div></li>
                            <li className={this.state.section==="consensus" ? "selected" : ""} onClick={this.handleOnClick('consensus')}><div className="text">コンセンサス</div><div className="counter" style={{display: this.getNumberOfSelectedItemByType("consensus")>0?"block":"none"}}>{this.getNumberOfSelectedItemByType("consensus")}</div></li>
                            <li className={this.state.section==="priceperf" ? "selected" : ""} onClick={this.handleOnClick('priceperf')}><div className="text">株価パフォーマンス</div><div className="counter" style={{display: this.getNumberOfSelectedItemByType("priceperf")>0?"block":"none"}}>{this.getNumberOfSelectedItemByType("priceperf")}</div></li>
                            <li className={this.state.section==="technical" ? "selected" : ""} onClick={this.handleOnClick('technical')}><div className="text">テクニカル</div><div className="counter" style={{display: this.getNumberOfSelectedItemByType("technical")>0?"block":"none"}}>{this.getNumberOfSelectedItemByType("technical")}</div></li>
                            <li className={this.state.section==="other" ? "selected" : ""} onClick={this.handleOnClick('other')}><div className="text">その他</div><div className="counter" style={{display: this.getNumberOfSelectedItemByType("other")>0?"block":"none"}}>{this.getNumberOfSelectedItemByType("other")}</div></li>
                        </ul>
                    </div>
                    <div className="container">
                        <div className="financial" style={{display: this.state.section==="financial"?"block":"none"}}>
                            {this.generateCriteria("financial")}
                            <div style={{clear: "both"}} />
                        </div>
                        <div className="consensus" style={{display: this.state.section==="consensus"?"block":"none"}}>
                            {this.generateCriteria("consensus")}
                            <div style={{clear: "both"}} />
                        </div>
                        <div className="priceperf" style={{display: this.state.section==="priceperf"?"block":"none"}}>
                            {this.generateCriteriaPriceperf("priceperf")}
                            <div style={{clear: "both"}} />
                        </div>
                        <div className="technical" style={{display: this.state.section==="technical"?"block":"none"}}>
                            {this.generateCriteria("technical")}
                            <div style={{clear: "both"}} />
                        </div>
                        <div className="other" style={{display: this.state.section==="other"?"block":"none"}}>
                            {this.generateCriteria("other")}
                            <div style={{clear: "both"}} />
                        </div>
                    </div>
                </div>
                <div className="simplemode" style={{display: this.state.mode==="simple"?"block":"none"}}>
                    <div className="criteriabar">
                        <ul>
                            <li>財務</li>
                            <li>コンセンサス</li>
                            <li>株価パフォーマンス</li>
                            <li>テクニカル/その他</li>
                        </ul>
                    </div>
                    <div className="container">
                        {this.generateSimpleCriteria("financial")}
                        {this.generateSimpleCriteria("consensus")}
                        {this.generateSimpleCriteria("priceperf")}
                        {this.generateSimpleCriteria(["technical", "other"])}
                        <div style={{clear: "both"}} />
                    </div>
                </div>
                <div className="confirmbtn" onClick={this.handleConfirm}>適用</div>
            </div>
        )
    }
}